import {getFirstOpenWidget, setFirstOpenWidget} from '@scripttag/helpers/sessionHelpers';
import {useWindowSize} from '@scripttag/hooks/useWindowSize';
import {useEffect, useRef, useState} from 'react';

const BOUNCE_ANIMATION_DURATION = 1200;
const BOUNCE_DELAY = 30000;

/**
 * Hook for triggering a bounce animation on a chat button after a set delay.
 * @param {boolean} isOpen Whether the chat is currently open.
 * @returns {array}
 */
export default function useBounceAnimation(isOpen) {
  const {isMobile} = useWindowSize();
  const [isShowBounce, setIsShowBounce] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const isFirstOpenWidget = getFirstOpenWidget();
    if (isFirstOpenWidget || isMobile) return;
    if (isOpen) setFirstOpenWidget(true);

    const setupInitialBounce = () => {
      if (isOpen) {
        clearTimeout(timeoutRef.current);
        return;
      }

      setIsShowBounce(true);
      timeoutRef.current = setTimeout(() => {
        setIsShowBounce(true);
      }, BOUNCE_DELAY);
    };
    const timeout = setTimeout(setupInitialBounce, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isShowBounce) return;
    const timeout = setTimeout(() => {
      setIsShowBounce(false);
    }, BOUNCE_ANIMATION_DURATION);

    return () => clearTimeout(timeout);
  }, [isShowBounce]);

  return [isShowBounce, setIsShowBounce];
}
